var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ProductDocuments50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#90caf9",
    d: "M35 41L13 41 13 5 35 5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#42a5f5",
    d: "M37 41L11 41 11 8 37 8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#90caf9",
    d: "M39 41L9 41 9 11 39 11z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M12 16H20V18H12zM22 16H29V18H22zM12 20H24V22H12z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#64b5f6",
    d: "M28,29v2c0,2.209-1.791,4-4,4s-4-1.791-4-4v-2H9v12h30V29H28z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M24,37c-3.313,0-6-2.687-6-6H7c-0.552,0-1,0.448-1,1v8c0,1.657,1.343,3,3,3h30c1.657,0,3-1.343,3-3 v-8c0-0.552-0.448-1-1-1H30C30,34.313,27.313,37,24,37z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ProductDocuments50);
export default __webpack_public_path__ + "static/media/icons8-product-documents-50.0fe9d6548ba5147fee69f2a9b420af9e.svg";
export { ForwardRef as ReactComponent };